import { createContext, useState, useEffect, useContext, ReactNode } from "react";
import { SessionProviderPHP } from "./SesionProviderPHP";

export interface User{
  id: number
  userEmail: string
  userPassword: string
}

interface LoginContextInterface{
  isLoggedIn: boolean
  loggedUser: User | null
  checkLoginStatus: () => boolean
  login: (userEmail: string, userPassword: string) => void
  logout: () => void
  getUserInfo: () => void
}



export const LoginContext = createContext<LoginContextInterface>({
  checkLoginStatus() {
    return false
  },
  getUserInfo(){},
  isLoggedIn: false,
  loggedUser: null,
  login(){},
  logout(){}
});

export function LoginContextProvider({ children }: {
  children: ReactNode
}) {
  const [isLoggedIn, setLoginStatus] = useState<boolean>(false);
  const [loggedUser, setLoggedUser] = useState<User | null>(null);
  const [refresh, setRefresh] = useState(0);

  const sessionProvider = new SessionProviderPHP("");

  function checkLoginStatus() {
    return isLoggedIn;
  }

  const login = async (userEmail: string, userPassword: string) => {
    const user: User = await sessionProvider.login(userEmail, userPassword);

    if (user) {
      setLoginStatus(true);
      setLoggedUser(user);
    }
  };

  const logout = async () => {
    await sessionProvider.logout();
    setLoginStatus(false);
    setLoggedUser(null);
    setRefresh((r) => r + 1)
  };

  const setUserLoginData = (user: User) => {
    setLoggedUser(user);
    setLoginStatus(true);
  };

  const getUserInfo = async () => {
    const userInfo = await sessionProvider.getUserInfo();
    if (userInfo) {
      setUserLoginData(userInfo);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, [refresh]);

  return (
    <LoginContext.Provider
      value={{
        isLoggedIn,
        loggedUser,
        checkLoginStatus,
        login,
        logout,
        getUserInfo,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
}
